/** Fondo global del layout de login (columna derecha pinta encima). */
export const DARK_BG = "#0a1220";

/** Acento global (barra izquierda, focus, botón principal). */
export const ACCENT = "#1E86F6";

export const LOGO_SRC =
  "https://www.payflexapp.com/_next/image?url=%2Fimages%2Flogo%2Flogo-2.png&w=384&q=75";

export const LOGO_WHITE_SRC = "https://www.payflexapp.com/images/logo/logo-white.svg";
